module.exports = __webpack_public_path__ + "img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.089352ac.svg";